<template>
  <div class="Jieji">
    <div class="container">
      <h2>机场接送服务</h2>
      <p>ZHUXUE为您提供从机场到大学的便捷旅程和注册服务。</p>
      <p>当你飞行数千英里后抵达机场时，你可能会遇到很多问题，比如出租车司机可能因为语言障碍将你带到了错误的地方，或者你到达后找不到学校登记处等。</p>
      <p>ZHUXUE接送服务将消除您的所有担忧。我们的工作人员将在机场的抵达区迎接您，并将举着印有您姓名和ZHUXUE标志的硬纸板标牌。此外，我们还为抵达北京的学生提供陪同登记服务。你所要做的就是订一张机票，告诉我们你的到达时间。</p>
      <div class="shenqingTit">提供机场接送服务的城市</div>
      <p>ZHUXUE在北京、长春、成都、重庆、广州、杭州、南京、上海和武汉提供机场接送服务，仅在北京提供陪同登记服务。</p>
      <p>· 接送服务费：100美元（如果多收一人，则另收50美元）</p>
      <p>· 登记服务费：100美元</p>
      <p>· 接机和登记服务费：200美元（仅限北京）</p>
      <div class="shenqingTit">抵达后程序</div>
      <div class="buzhu">
        <van-steps direction="vertical"
                   :active="10">
          <van-step>
            <h3>STEP 1</h3>
            <div class="lis">
              <h4>预订机场接机服务：单击“<span @click="showForm = true"
                      style="color:#263e65">机场接送服务</span>”预订。</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 2</h3>
            <div class="lis">
              <h4>支付费用</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 3</h3>
            <div class="lis">
              <h4>从机场接机</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 4</h3>
            <div class="lis">
              <h4>完成学校注册登记（仅限北京）</h4>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="shenqingTit">服务标准</div>
      <p>机场接送服务</p>
      <p>ZHUXU将在您预订机票后一个工作日与您确认到达信息。</p>
      <p>ZHUXUE将在您出发前三天再次确认抵达信息。</p>
      <div class="shenqingTit">登记服务</div>
      <p>ZHUXUE工作人员能清晰流利地说英语和汉语，将帮助您与招生办公室人员进行沟通。</p>
      <p>如有必要，ZHUXUE工作人员将帮助您注册当地手机号码和银行账户。</p>
      <p>同时，ZHUXUE工作人员也很乐意带你熟悉新环境。在工作人员的指导下，你会更容易安顿下来。在校园里，他们会引导你参观教学楼和图书馆。他们还会告诉你体育设施的位置。此外，他们还会带你去银行了解如何使用国际信用卡、借记卡和ATM机取钱，以及给你推荐附近的餐厅、超市、洗衣店、邮局、药店和最近的地铁站。</p>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=7
                 formTitle="机场接送服务"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'

export default {
  name: 'Jieji',
  components: {
    ComForm
  },
  data () {
    return {
      activeNames: ['0'],
      faq: [{
        ft: '在什么情况下我的预订会失败？',
        fa: '以下两种情况可能导致宿舍预订失败：您所在的大学不提供校内宿舍；宿舍不足。'
      },
      {
        ft: '我可以住在校外吗？',
        fa: '这是许多中国大学所允许的。'
      },
      {
        ft: '我能让我的家人和我一起住在校园里吗？',
        fa: '这是某些中国大学允许的。'
      },
      {
        ft: '我在申请表中勾选了单人房，为什么会显示双人房预订？',
        fa: '由于数量不足，贵校无法满足所有学生的要求。如果您同意转房，助学将为您预订双人房，以保证您在校园内的住宿。'
      },
      {
        ft: '我到达时住宿费会调整吗？',
        fa: '助学及其他相关文件的信息均来自学校，仅供参考。注册期间可能会发生变更。'
      },
      {
        ft: '我可以在注册期前办理登机手续吗？',
        fa: '一些大学允许学生在注册日期之前来。'
      },
      {
        ft: '如果我错过了注册怎么办？',
        fa: '大学要求学生按时注册。如果你不准时，你应该立即与助学或你所在的大学联系，请求允许。否则，您将被视为放弃注册。'
      },
      {
        ft: '我没有预订住宿。如果我到达时没有房间，我该怎么办？',
        fa: '助学建议学生提前预订住宿。如果您到达后没有房间，请联系学校或助学寻求帮助。助学可以在校外找到住宿信息。'
      }
      ],
      showForm: false
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
.container {
  padding-bottom: 0;
  h2 {
    text-align: center;
  }
  h4 {
    margin: 0;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
